// extracted by mini-css-extract-plugin
export default {"numerals-demo":"numerals-demo_OklI","numerals-demo__input":"numerals-demo__input_Dv05","numerals-demo__output":"numerals-demo__output_itxJ"};